import React from 'react'
import { faC } from '@fortawesome/free-solid-svg-icons';

interface userInfoProps {
  name: string,
  insurance: string,
  policy: string,
  prefix: string,
  facility: string,
  dob: string,
}

const UserInfo:React.FC<userInfoProps> = (props) => {
  const {name, insurance, policy, prefix, facility, dob} = props
  return (
    <div className='w-full p-4 text-black dark:text-white'>
      <div>
        <p className='text-4xl font-bold pb-4'>{name}</p>
      </div>
      <div className='flex flex-row items-center'>
        <p className='text-xl'>{prefix}</p>
        <p className='text-2xl mx-2'>|</p>
        <p className='text-xl'>{policy}</p>
        <p className='text-2xl mx-2'>|</p>
        <p className='text-xl'>{insurance}</p>
        <p className='text-2xl  mx-2'>|</p>
        <p className='text-xl'>{dob}</p>
      </div>
    </div>
  )
}

export default UserInfo
